import mediaFormats from '../../shared/mediaFormats.json';
import { createTranscriptionError } from './errors';

export const AUDIO_MEDIA_EXTENSIONS = Object.freeze([...mediaFormats.audioExtensions]);
export const VIDEO_MEDIA_EXTENSIONS = Object.freeze([...mediaFormats.videoExtensions]);
export const SUPPORTED_MEDIA_EXTENSIONS = Object.freeze([...new Set([
  ...AUDIO_MEDIA_EXTENSIONS,
  ...VIDEO_MEDIA_EXTENSIONS,
])]);

const EXTENSION_BY_MIME_TYPE = Object.freeze({ ...mediaFormats.mimeExtensionMap });

export const MEDIA_FILE_ACCEPT = Object.freeze([
  'audio/*',
  'video/*',
  ...SUPPORTED_MEDIA_EXTENSIONS.map((extension) => `.${extension}`),
]).join(',');

export function getFileExtension(file) {
  const extension = getRawFileExtension(file);
  if (SUPPORTED_MEDIA_EXTENSIONS.includes(extension)) return extension;

  const mimeType = String(file?.type || '').split(';', 1)[0].trim().toLowerCase();
  return EXTENSION_BY_MIME_TYPE[mimeType] || 'unknown';
}

export function isSupportedMediaFile(file) {
  return Boolean(file) && getFileExtension(file) !== 'unknown';
}

export function validateMediaFile(file) {
  if (file?.size === 0) {
    throw createTranscriptionError(
      'El fitxer està buit. Torna’l a exportar o selecciona’n un altre.',
      { code: 'EMPTY_MEDIA_FILE', phase: 'file-validation' },
    );
  }
  if (!isSupportedMediaFile(file)) {
    throw createTranscriptionError(
      'Selecciona un fitxer d’àudio o vídeo compatible.',
      { code: 'UNSUPPORTED_MEDIA_FILE', phase: 'file-validation' },
    );
  }
  return file;
}

export function getRawFileExtension(file) {
  return file?.name?.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1] || null;
}

export function getMediaFileDiagnostics(file) {
  if (!file) return null;

  const resolvedExtension = getFileExtension(file);
  const lastModified = Number.isFinite(file.lastModified) && file.lastModified > 0
    ? new Date(file.lastModified).toISOString()
    : null;

  return {
    extension: getRawFileExtension(file),
    lastModified,
    mimeType: String(file.type || 'unknown'),
    name: String(file.name || 'unknown'),
    resolvedExtension,
    sizeBytes: Number.isFinite(file.size) ? file.size : null,
    supported: resolvedExtension !== 'unknown',
  };
}
